"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventSearchQueryBuilder = void 0;
var graphql_tag_1 = require("graphql-tag");
var eventSearchQuery = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query EventSearch($status: Status, $from: Int, $limit: Int) {\n      eventSearch(status: $status, from: $from, limit: $limit) {\n        totalCount,\n        results {\n          id,\n          name,\n          date {\n            dateTime,\n            timeZone\n          },\n          location {\n            locality,\n            country,\n            region\n          },\n          timestamp {\n            dateTime,\n            timeZone\n          }\n        }\n      }\n    }\n  "], ["\n    query EventSearch($status: Status, $from: Int, $limit: Int) {\n      eventSearch(status: $status, from: $from, limit: $limit) {\n        totalCount,\n        results {\n          id,\n          name,\n          date {\n            dateTime,\n            timeZone\n          },\n          location {\n            locality,\n            country,\n            region\n          },\n          timestamp {\n            dateTime,\n            timeZone\n          }\n        }\n      }\n    }\n  "])));
var eventSearchQueryBuilder = function (_a) {
    var status = _a.status, fro = _a.fro, limit = _a.limit, token = _a.token;
    var mappedArgs = {
        status: 'Pending',
        from: fro || 0,
        limit: limit || 25,
        token: token
    };
    return {
        query: eventSearchQuery,
        variables: mappedArgs
    };
};
exports.eventSearchQueryBuilder = eventSearchQueryBuilder;
var templateObject_1;
//# sourceMappingURL=queries.js.map